import type { ClientTaskCompletionStatus } from '@shared/modules/client-task-completions/client-task-completion';
import { Presenter } from '@shared/presenters/presenter';

export class ClientTaskCompletionStatusPresenter extends Presenter<ClientTaskCompletionStatus> {

    get name() {
        return this._data.name;
    }

    get code() {
        return this._data.code.toUpperCase();
    }

    get alertable() {
        return this._data.alertable;
    }

}
